// prod: dữ liệu thật của các CLB. dev: Firebase riêng để thử, dùng cho link xem thử.
export const FIREBASE = {
  prod: {
    apiKey: "AIzaSyAr_pRMZ1kuelswYpAg6VjTYv1vYpVtmcc",
    authDomain: "keo-pickleball.firebaseapp.com",
    projectId: "keo-pickleball",
    storageBucket: "keo-pickleball.firebasestorage.app",
    messagingSenderId: "882121758141",
    appId: "1:882121758141:web:aa6d2c990c3011cb732ed4"
  },
  dev: {
    apiKey: "AIzaSyCbCYsuyrXkPuYLt1e2DxmPg8fFhbpXvbM",
    authDomain: "pikeco-dev-53834.firebaseapp.com",
    projectId: "pikeco-dev-53834",
    storageBucket: "pikeco-dev-53834.firebasestorage.app",
    messagingSenderId: "916980956435",
    appId: "1:916980956435:web:d5744a7dc7faf3604f6ee6"
  }
};
